import { useTranslation } from 'react-i18next';
import { StoryCardType } from '../../../services';

export const useCardTypeFilter = () => {
  const { t } = useTranslation();

  return {
    group: {
      id: 'card-type',
      title: t('common.card-type'),
      multiCheck: true,
      allowReset: true,
      items: Object.values(StoryCardType).map((type) => ({
        id: type,
        label: t(`cardTypes.${type.toLowerCase()}`),
        value: type,
      })),
    },
  };
};
